import actionTypes from './actionTypes';
import { action, generateErrorAction } from '../actions';
import API from '../../apis';
import { store } from '../configureStore';

export const newReservationTiming = data => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservationTiming
        .newReservationTiming(data)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.INSERT_NEW_RESERVATION_TIMING_FAILED,
              reject: actionTypes.INSERT_NEW_RESERVATION_TIMING_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.INSERT_NEW_RESERVATION_TIMING_LOADING);
  const success = res => action(actionTypes.INSERT_NEW_RESERVATION_TIMING_SUCCESS, res);

  return request();
};

export const editReservationTiming = data => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservationTiming
        .editReservationTiming(data)
        .then(() => {
          const { reservationTimingList } = store.getState().reservationTimetableReducer;
          const index = reservationTimingList.findIndex(item => item.id === data.id);
          const updateList = [...reservationTimingList];
          updateList[index] = { ...data };
          dispatch(success(updateList));
        })
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.UPDATE_RESERVATION_TIMING_FAILED,
              reject: actionTypes.UPDATE_RESERVATION_TIMING_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.UPDATE_RESERVATION_TIMING_LOADING);
  const success = res => action(actionTypes.UPDATE_RESERVATION_TIMING_SUCCESS, res);

  return request();
};

export const getReservationTimingList = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservationTiming
        .getReservationTimingList(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_ALL_RESERVATION_TIMING_LIST_FAILED,
              reject: actionTypes.GET_ALL_RESERVATION_TIMING_LIST_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_ALL_RESERVATION_TIMING_LIST_LOADING);
  const success = res => action(actionTypes.GET_ALL_RESERVATION_TIMING_LIST_SUCCESS, res);

  return request();
};

export const getReservationTimingDetails = id => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservationTiming
        .getReservationTimingDetails(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_RESERVATION_TIMING_DETAILS_FAILED,
              reject: actionTypes.GET_RESERVATION_TIMING_DETAILS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_RESERVATION_TIMING_DETAILS_LOADING);
  const success = res => action(actionTypes.GET_RESERVATION_TIMING_DETAILS_SUCCESS, res);

  return request();
};

export const deleteReservationTimingByDay = id => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.reservationTiming
        .deleteReservationTimingByDay(id)
        .then(() => {
          const { reservationTimingList } = store.getState().reservationTimetableReducer;
          const updateList = reservationTimingList.filter(item => item.id !== id);
          dispatch(success(updateList));
        })
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.DELETE_RESERVATION_TIMING_FAILED,
              reject: actionTypes.DELETE_RESERVATION_TIMING_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.DELETE_RESERVATION_TIMING_LOADING);
  const success = res => action(actionTypes.DELETE_RESERVATION_TIMING_SUCCESS, res);

  return request();
};